import { logPerformanceEvent, PerformanceEventType } from './logSigningEvent';
import {trackGoal} from "./trackGoal";

interface PerformanceMetrics {
    firstContentfulPaint: number;
    domInteractive: number;
    domComplete: number;
    loadTime: number;
    bundleSize: number;
}

interface ResourceEntry extends PerformanceEntry {
    initiatorType: string;
    transferSize: number;
    duration: number;
    encodedBodySize: number;
    name: string;
}

export function trackPerformance(): void {
    if (typeof window === 'undefined') return;

    // Получаем метрики загрузки страницы
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    if (!navigation) {
        console.warn('Не удалось получить метрики навигации');
        return;
    }

    // Собираем метрики загрузки страницы
    const metrics: PerformanceMetrics = {
        firstContentfulPaint: performance.getEntriesByType('paint')
            .find(entry => entry.name === 'first-contentful-paint')?.startTime || 0,
        domInteractive: navigation.domInteractive,
        domComplete: navigation.domComplete,
        loadTime: navigation.loadEventEnd - navigation.startTime,
        bundleSize: (performance.getEntriesByType('resource') as ResourceEntry[])
            .filter(entry => entry.initiatorType === 'script')
            .reduce((total, entry) => total + (entry.transferSize || entry.encodedBodySize || 0), 0)
    };

    // Проверяем корректность метрик
    if (metrics.domComplete < 0 || metrics.loadTime < 0 || metrics.domInteractive < 0) {
        console.warn('Некорректные метрики загрузки страницы:', metrics);
        return;
    }

    // Отправляем метрики в аналитику
    trackGoal(
        'page_load_metrics',
        {
            ...metrics,
            bundleSizeFormatted: formatBytes(metrics.bundleSize)
        }
    );

    // Логируем метрики через logPerformanceEvent
    logPerformanceEvent({
        eventType: PerformanceEventType.PAGE_LOAD_METRICS,
        firstContentfulPaint: metrics.firstContentfulPaint,
        domInteractive: metrics.domInteractive,
        domComplete: metrics.domComplete,
        loadTime: metrics.loadTime,
        bundleSize: metrics.bundleSize
    });
}

function formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
} 